import { ExternalTextLink } from "@/components/Links";
import OrderTestItemStatusBadges from "@/components/OrderTestItemStatusBadges";
import { OrderedReportStatusBadge } from "@/components/reports/Badges";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { CMP_PATIENTS_TEST_RESULT_URL, getCmpUrl } from "@/core/urls";
import Group from "@/tpo/Group";
import {
  PROGRESS_STATUS_INTERIM_RESULTS_RELEASED,
  PROGRESS_STATUS_PARTIAL_RESULTS_RELEASED,
  PROGRESS_STATUS_RESULTS_RELEASED,
  PROGRESS_STATUS_REVIEW_RESULTS
} from "@/tpo/shop/constants";

export default function CmpOrderTestItemStatusBadges({
  order,
  orderTestItem,
  badgeProps,
  ...props
}) {
  const { organisation } = useOrganisationContext();

  const organisationId = organisation?.hashId;

  const isReportLineItem = orderTestItem?.hasUserReport != null;

  let progressStatusBadgeProps = {};

  if (
    [
      PROGRESS_STATUS_REVIEW_RESULTS,
      PROGRESS_STATUS_INTERIM_RESULTS_RELEASED,
      PROGRESS_STATUS_RESULTS_RELEASED,
      PROGRESS_STATUS_PARTIAL_RESULTS_RELEASED
    ].includes(orderTestItem.derivedProgressStatus)
  ) {
    const patientId = orderTestItem?.patientUserId;
    const userTestId = orderTestItem?.patientUserTestId;
    const href =
      patientId &&
      userTestId &&
      getCmpUrl(CMP_PATIENTS_TEST_RESULT_URL, {
        patientId,
        userTestId,
        organisationId
      });

    if (href) {
      progressStatusBadgeProps = {
        ...progressStatusBadgeProps,
        as: ExternalTextLink,
        href,
        underline: false,
        onClick: e => {
          e.stopPropagation();
        }
      };
    }
  }

  if (isReportLineItem) {
    return (
      <Group gap={10} alignItems="center" alignSelf="flex-start" flexWrap="wrap" {...props}>
        <OrderedReportStatusBadge hasUserReport={orderTestItem.hasUserReport} />
      </Group>
    );
  }

  return (
    <OrderTestItemStatusBadges
      progressStatusBadgeProps={progressStatusBadgeProps}
      orderTestItem={orderTestItem}
      badgeProps={badgeProps}
      {...props}
    />
  );
}
